import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";



class ZhongxPrvacy extends React.PureComponent {
    componentDidMount() {
        document.title = this.props.intl.formatMessage({ id: 'PrivacyPolicy' })
    }

    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };

    render() {
        const { pwr, intl, history } = this.props;
        return (
            <div className={style.ZhongxPrvacy}>
                <div dangerouslySetInnerHTML={{ __html: this.strs('ZhongxPrvacy') }}></div>
            </div>
        )
    }
}



export default inject()(injectIntl(ZhongxPrvacy));